
<div class="fixed top-6 right-6 z-[9999] flex flex-col items-end gap-3 w-full max-w-sm pointer-events-none">
  @for (n of notifications(); track n.id) {
    <div 
      [class]="'w-full flex flex-col p-4 rounded-xl shadow-2xl border-l-4 text-white animate-fade-in-right pointer-events-auto backdrop-blur-md ' + getBgClass(n.type)"
      role="alert">
      
      <!-- Header Row -->
      <div class="flex items-start gap-3">
          <div class="flex-shrink-0 text-xl mt-0.5">
            <i [class]="getIconClass(n.type)"></i>
          </div>
          <div class="flex-grow min-w-0">
            @if(n.title) {
                <h4 class="font-bold text-base leading-tight mb-1">{{ n.title }}</h4>
            }
            <p [class]="n.title ? 'text-sm opacity-90' : 'font-bold text-sm leading-tight'">{{ n.message }}</p>
          </div>
          <button (click)="removeNotification(n.id)"
            aria-label="ปิดการแจ้งเตือน" 
            title="ปิดการแจ้งเตือน" class="flex-shrink-0 text-white/50 hover:text-white transition-colors p-1 -mt-1 -mr-1">
            <i class="fa-solid fa-times text-sm"></i>
          </button>
      </div>

      <!-- Suggestion Row -->
      @if(n.suggestion) {
          <div class="mt-2 ml-8 text-xs bg-black/10 p-2 rounded border border-white/10">
              <i class="fa-regular fa-lightbulb mr-1"></i> {{ n.suggestion }}
          </div>
      }

      <!-- Action Button -->
      @if(n.actionLabel && n.actionLink) {
          <div class="mt-3 ml-8">
              <button (click)="onActionClick(n)" class="bg-white/20 hover:bg-white/30 text-white text-xs font-bold py-1.5 px-3 rounded transition-colors border border-white/30">
                  {{ n.actionLabel }} <i class="fa-solid fa-arrow-right ml-1"></i>
              </button>
          </div>
      }
    </div>
  }
</div>
